import React from 'react';
import { View, KeyboardAvoidingView, Platform } from 'react-native';
import Expo from 'expo';
import { css, theme } from 'constants';

const styles = css({
  scene: {
    flex: 1,
    backgroundColor: 'white'
  }
});

export const Scene = ({ avoidKeyboard, style, content_style, ...props }) =>
  avoidKeyboard && Platform.OS !== 'web' ? (
    <KeyboardAvoidingView style={[styles.scene, style]} contentContainerStyle={[styles.scene, content_style]} behavior={'padding'} {...props} />
  ) : (
    <View style={[styles.scene, style]} {...props} />
  );

const BlurViewWeb = ({ children, style, intensity, ...props }) => {
  const bg_color = `rgba(252, 253, 253,0.99)`;
  //const bg_color = `rgba(255, 255, 255,${intensity ? intensity / 100 : 0.99})`;

  return (
    <View style={[{ backgroundColor: bg_color }, style]} {...props}>
      {children}
    </View>
  );
};

export const BlurView = Platform.OS === 'web' ? BlurViewWeb : Expo.BlurView;



// WEBPACK FOOTER //
// ./src/components/core/scene.js